/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Segment_InvalidInputs */

const en_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment is invalid - start must be earlier than end, and both must be inside the video.`)
};

const fr_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le segment est invalide : le début doit être antérieur à la fin, et les deux doivent se trouver à l’intérieur de la vidéo.`)
};

const de_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Segment ist ungültig – der Startpunkt muss vor dem Ende liegen, und beide müssen innerhalb des Videos liegen.`)
};

const it_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il segmento non è valido: l'inizio deve essere precedente alla fine ed entrambi devono trovarsi all'interno del video.`)
};

const ru_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недопустимый сегмент — начало должно быть раньше конца, и оба момента должны находиться внутри видео.`)
};

const es_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El segmento no es válido: el inicio debe ser anterior al final, y ambos deben estar dentro del vídeo.`)
};

const zh_cn2_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`片段无效——开始时间必须早于结束时间，并且两者都必须在视频内部。`)
};

const ja_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントが無効です。開始位置は終了位置より前である必要があり、両方とも動画内に含まれていなければなりません。`)
};

const hi_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह सेगमेंट अमान्य है - शुरुआत अंत से पहले होनी चाहिए, और दोनों वीडियो के अंदर होने चाहिए।`)
};

const pt_pt2_sd_segment_invalid = /** @type {(inputs: Sd_Segment_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O segmento é inválido - o início deve ser anterior ao fim, e ambos devem estar dentro do vídeo.`)
};

/**
* | output |
* | --- |
* | "Segment is invalid - start must be earlier than end, and both must be inside the video." |
*
* @param {Sd_Segment_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_segment_invalid = /** @type {((inputs?: Sd_Segment_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Segment_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sd_segment_invalid(inputs)
	if (locale === "de") return de_sd_segment_invalid(inputs)
	if (locale === "it") return it_sd_segment_invalid(inputs)
	if (locale === "ru") return ru_sd_segment_invalid(inputs)
	if (locale === "es") return es_sd_segment_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_sd_segment_invalid(inputs)
	if (locale === "ja") return ja_sd_segment_invalid(inputs)
	if (locale === "hi") return hi_sd_segment_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_sd_segment_invalid(inputs)
	return en_sd_segment_invalid(inputs)
});